"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/features/array/includes");
var debug_1 = require("debug");
var client_1 = require("./client");
var R = require("./request");
var validation_1 = require("./validation");
var settings = require("./settings");
var knownEnvs = ['development', 'staging', 'production'];
var defaultEnv = 'production';
var findifyEnv = typeof process !== 'undefined' && process.env && process.env.FINDIFY_ENV;
var env = findifyEnv || defaultEnv;
if (!knownEnvs.includes(env)) {
    throw new Error(env + " is not supported environment");
}
var defaults = settings[env];
function init(config) {
    var isBrowserEnv = typeof window !== 'undefined';
    debug_1.default('sdk')('env: ', env);
    debug_1.default('sdk')('defaults: ', defaults);
    debug_1.default('sdk')('isBrowserEnv: ', isBrowserEnv);
    var cfg = setDefaults(config, isBrowserEnv);
    validation_1.validateConfig(cfg, isBrowserEnv);
    return new client_1.Client(cfg);
}
exports.init = init;
var setDefaults = function (cfg, isBrowserEnv) { return (__assign({ method: isBrowserEnv ? R.Method.JSONP : R.Method.POST }, defaults, cfg)); };
//# sourceMappingURL=index.js.map